import React from 'react'
import { AppFooter } from '@/components/molecules/app-footer'

interface FullLayoutProps {
  children: React.ReactNode
}

export function FullLayout({ children }: FullLayoutProps) {
  return (
    <div className="flex h-[100dvh] flex-col overflow-hidden">
      <main className="min-h-0 flex-1 overflow-y-auto">{children}</main>
      <AppFooter />
    </div>
  )
}
